export const categories = [
  {
    slug: 'zonghe-menhu',
    name: '综合门户',
    icon: 'ri-global-line',
    description: '汇聚全网热门综合类网站，一站式信息服务平台',
    color: 'primary',
  },
  {
    slug: 'sousuo-yinqing',
    name: '搜索引擎',
    icon: 'ri-search-eye-line',
    description: '国内外主流搜索引擎，快速找到所需信息',
    color: 'accent',
  },
  {
    slug: 'shejiao-meiti',
    name: '社交媒体',
    icon: 'ri-chat-smile-2-line',
    description: '主流社交平台，连接世界每一个角落',
    color: 'secondary',
  },
  {
    slug: 'shipin-yule',
    name: '视频娱乐',
    icon: 'ri-movie-2-line',
    description: '视频播放、直播、短视频平台一网打尽',
    color: 'primary',
  },
  {
    slug: 'gouwu-xiaofei',
    name: '购物消费',
    icon: 'ri-shopping-bag-3-line',
    description: '优选电商购物平台，畅享便捷在线消费',
    color: 'accent',
  },
  {
    slug: 'xuexi-jiaoyu',
    name: '学习教育',
    icon: 'ri-book-open-line',
    description: '在线课程、知识分享、学术资源汇聚地',
    color: 'secondary',
  },
  {
    slug: 'xinwen-zixun',
    name: '新闻资讯',
    icon: 'ri-newspaper-line',
    description: '实时新闻、深度报道，掌握天下大事',
    color: 'primary',
  },
  {
    slug: 'gongju-ziyuan',
    name: '工具资源',
    icon: 'ri-tools-line',
    description: '实用在线工具、开发者资源、效率利器',
    color: 'accent',
  },
  {
    slug: 'shenghuo-fuwu',
    name: '生活服务',
    icon: 'ri-heart-pulse-line',
    description: '衣食住行、健康医疗、便民服务一站通',
    color: 'secondary',
  },
  {
    slug: 'keji-it',
    name: '科技IT',
    icon: 'ri-computer-line',
    description: '科技资讯、技术社区、开源项目聚集地',
    color: 'primary',
  },
];

export const sites = [
  {
    id: 1,
    name: '百度',
    url: 'https://www.baidu.com',
    description: '全球最大的中文搜索引擎，提供网页、图片、视频等多种搜索服务',
    category: 'sousuo-yinqing',
    tags: ['搜索', '中文'],
    featured: true,
  },
  {
    id: 2,
    name: '谷歌',
    url: 'https://www.google.com',
    description: '全球领先的搜索引擎，提供精准全面的搜索体验',
    category: 'sousuo-yinqing',
    tags: ['搜索', '全球'],
    featured: true,
  },
  {
    id: 3,
    name: '必应',
    url: 'https://www.bing.com',
    description: '微软旗下的搜索引擎，每日精美壁纸与智能搜索结合',
    category: 'sousuo-yinqing',
    tags: ['搜索', '微软'],
    featured: false,
  },
  {
    id: 4,
    name: '新浪',
    url: 'https://www.sina.com.cn',
    description: '国内领先的综合门户网站，涵盖新闻、体育、财经、娱乐等频道',
    category: 'zonghe-menhu',
    tags: ['门户', '新闻'],
    featured: true,
  },
  {
    id: 5,
    name: '搜狐',
    url: 'https://www.sohu.com',
    description: '中国知名互联网品牌，提供新闻、视频、搜索等综合服务',
    category: 'zonghe-menhu',
    tags: ['门户', '新闻'],
    featured: false,
  },
  {
    id: 6,
    name: '网易',
    url: 'https://www.163.com',
    description: '领先的互联网技术公司，新闻、邮箱、游戏等多业务发展',
    category: 'zonghe-menhu',
    tags: ['门户', '邮箱'],
    featured: true,
  },
  {
    id: 7,
    name: '腾讯网',
    url: 'https://www.qq.com',
    description: '腾讯旗下综合门户网站，集新闻、娱乐、社交于一体',
    category: 'zonghe-menhu',
    tags: ['门户', '腾讯'],
    featured: false,
  },
  {
    id: 8,
    name: '微信',
    url: 'https://weixin.qq.com',
    description: '腾讯旗下的即时通讯社交平台，连接超过十亿用户',
    category: 'shejiao-meiti',
    tags: ['社交', '即时通讯'],
    featured: true,
  },
  {
    id: 9,
    name: '微博',
    url: 'https://weibo.com',
    description: '中国最大的社交媒体平台之一，实时热点话题聚集地',
    category: 'shejiao-meiti',
    tags: ['社交', '热搜'],
    featured: true,
  },
  {
    id: 10,
    name: '知乎',
    url: 'https://www.zhihu.com',
    description: '高质量中文问答社区，汇聚各领域专业人士的真知灼见',
    category: 'shejiao-meiti',
    tags: ['问答', '知识'],
    featured: true,
  },
  {
    id: 11,
    name: '豆瓣',
    url: 'https://www.douban.com',
    description: '书影音评分与社区交流平台，发现志同道合的朋友',
    category: 'shejiao-meiti',
    tags: ['社区', '书影音'],
    featured: false,
  },
  {
    id: 12,
    name: '哔哩哔哩',
    url: 'https://www.bilibili.com',
    description: '国内知名的视频弹幕网站，ACG文化与知识分享社区',
    category: 'shipin-yule',
    tags: ['视频', '弹幕', 'ACG'],
    featured: true,
  },
  {
    id: 13,
    name: '优酷',
    url: 'https://www.youku.com',
    description: '阿里巴巴旗下视频平台，海量影视综艺资源',
    category: 'shipin-yule',
    tags: ['视频', '影视'],
    featured: false,
  },
  {
    id: 14,
    name: '爱奇艺',
    url: 'https://www.iqiyi.com',
    description: '高品质视频娱乐服务平台，海量正版高清影视内容',
    category: 'shipin-yule',
    tags: ['视频', '影视'],
    featured: true,
  },
  {
    id: 15,
    name: '抖音',
    url: 'https://www.douyin.com',
    description: '字节跳动旗下短视频社交平台，记录美好生活',
    category: 'shipin-yule',
    tags: ['短视频', '社交'],
    featured: true,
  },
  {
    id: 16,
    name: '淘宝',
    url: 'https://www.taobao.com',
    description: '阿里巴巴旗下电商平台，万能的购物天堂',
    category: 'gouwu-xiaofei',
    tags: ['电商', '购物'],
    featured: true,
  },
  {
    id: 17,
    name: '京东',
    url: 'https://www.jd.com',
    description: '中国自营式电商企业，正品保障与高效物流体验',
    category: 'gouwu-xiaofei',
    tags: ['电商', '自营'],
    featured: true,
  },
  {
    id: 18,
    name: '拼多多',
    url: 'https://www.pinduoduo.com',
    description: '新电商开创者，拼团购物享实惠',
    category: 'gouwu-xiaofei',
    tags: ['电商', '拼团'],
    featured: false,
  },
  {
    id: 19,
    name: '中国大学MOOC',
    url: 'https://www.icourse163.org',
    description: '国内优质的中文MOOC学习平台，汇集名校精品课程',
    category: 'xuexi-jiaoyu',
    tags: ['教育', '在线课程'],
    featured: true,
  },
  {
    id: 20,
    name: '网易公开课',
    url: 'https://open.163.com',
    description: '汇集国内外名校公开课资源，让知识没有边界',
    category: 'xuexi-jiaoyu',
    tags: ['教育', '公开课'],
    featured: false,
  },
  {
    id: 21,
    name: '学堂在线',
    url: 'https://www.xuetangx.com',
    description: '清华大学发起的精品中文慕课平台',
    category: 'xuexi-jiaoyu',
    tags: ['教育', '慕课'],
    featured: false,
  },
  {
    id: 22,
    name: 'CSDN',
    url: 'https://www.csdn.net',
    description: '全球知名中文IT技术交流平台，开发者学习成长社区',
    category: 'xuexi-jiaoyu',
    tags: ['技术', '开发者'],
    featured: true,
  },
  {
    id: 23,
    name: '新华网',
    url: 'https://www.xinhuanet.com',
    description: '中国国家通讯社主办的综合新闻信息服务门户网站',
    category: 'xinwen-zixun',
    tags: ['新闻', '官方'],
    featured: true,
  },
  {
    id: 24,
    name: '人民网',
    url: 'https://www.people.com.cn',
    description: '人民日报建设的以新闻为主的大型网上信息发布平台',
    category: 'xinwen-zixun',
    tags: ['新闻', '官方'],
    featured: false,
  },
  {
    id: 25,
    name: '今日头条',
    url: 'https://www.toutiao.com',
    description: '字节跳动旗下个性化资讯推荐引擎，你关心的才是头条',
    category: 'xinwen-zixun',
    tags: ['资讯', '推荐'],
    featured: true,
  },
  {
    id: 26,
    name: 'Canva可画',
    url: 'https://www.canva.cn',
    description: '在线图形设计平台，轻松制作海报、PPT、社交媒体图片',
    category: 'gongju-ziyuan',
    tags: ['设计', '在线工具'],
    featured: true,
  },
  {
    id: 27,
    name: 'ProcessOn',
    url: 'https://www.processon.com',
    description: '免费在线流程图思维导图制作工具，团队协作更高效',
    category: 'gongju-ziyuan',
    tags: ['思维导图', '协作'],
    featured: false,
  },
  {
    id: 28,
    name: 'GitHub',
    url: 'https://github.com',
    description: '全球最大的代码托管平台，开源项目的聚集地',
    category: 'gongju-ziyuan',
    tags: ['代码', '开源'],
    featured: true,
  },
  {
    id: 29,
    name: 'Gitee码云',
    url: 'https://gitee.com',
    description: '国内领先的代码托管与协作开发平台',
    category: 'gongju-ziyuan',
    tags: ['代码', '国内'],
    featured: false,
  },
  {
    id: 30,
    name: '12306',
    url: 'https://www.12306.cn',
    description: '中国铁路客户服务中心官方网站，火车票在线预订',
    category: 'shenghuo-fuwu',
    tags: ['出行', '火车票'],
    featured: true,
  },
  {
    id: 31,
    name: '高德地图',
    url: 'https://www.amap.com',
    description: '国内领先的数字地图和导航服务提供商',
    category: 'shenghuo-fuwu',
    tags: ['地图', '导航'],
    featured: true,
  },
  {
    id: 32,
    name: '美团',
    url: 'https://www.meituan.com',
    description: '生活服务电子商务平台，吃喝玩乐全都有',
    category: 'shenghuo-fuwu',
    tags: ['生活', '团购'],
    featured: true,
  },
  {
    id: 33,
    name: '丁香园',
    url: 'https://www.dxy.cn',
    description: '中国领先的医疗领域连接者及数字化服务提供商',
    category: 'shenghuo-fuwu',
    tags: ['医疗', '健康'],
    featured: false,
  },
  {
    id: 34,
    name: '36氪',
    url: 'https://36kr.com',
    description: '中国领先的科技新媒体，报道最新的科技新闻和创业资讯',
    category: 'keji-it',
    tags: ['科技', '创业'],
    featured: true,
  },
  {
    id: 35,
    name: '虎嗅',
    url: 'https://www.huxiu.com',
    description: '聚合优质创新信息与人群的科技媒体平台',
    category: 'keji-it',
    tags: ['科技', '商业'],
    featured: false,
  },
  {
    id: 36,
    name: '少数派',
    url: 'https://sspai.com',
    description: '高品质数字消费指南，推荐效率工具和数字生活方式',
    category: 'keji-it',
    tags: ['效率', '数字生活'],
    featured: true,
  },
  {
    id: 37,
    name: 'V2EX',
    url: 'https://www.v2ex.com',
    description: '创意工作者社区，分享技术、设计和创业话题',
    category: 'keji-it',
    tags: ['社区', '技术'],
    featured: false,
  },
  {
    id: 38,
    name: '站酷',
    url: 'https://www.zcool.com.cn',
    description: '中国设计师互动平台，发现优秀设计与创意人才',
    category: 'gongju-ziyuan',
    tags: ['设计', '素材'],
    featured: false,
  },
  {
    id: 39,
    name: '搜狗搜索',
    url: 'https://www.sogou.com',
    description: '腾讯旗下搜索品牌，支持微信和知乎内容搜索',
    category: 'sousuo-yinqing',
    tags: ['搜索', '微信'],
    featured: false,
  },
  {
    id: 40,
    name: '小红书',
    url: 'https://www.xiaohongshu.com',
    description: '年轻人的生活方式平台，发现美好生活灵感',
    category: 'shejiao-meiti',
    tags: ['社区', '生活方式'],
    featured: true,
  },
];